
export class PlanGoodsGWStopModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード環境
   */
  // 温暖化防止関連商品区分
  public gWStopGoodsDiv: string = <string>'';

  // 温暖化防止選択
  public gWStopGoodsDivSelect: string = <string>'';

}